<template>
  <div>
    <b-card no-body class="p-0">
      <accordion
        v-for="(aba, i) in abas"
        :key="aba.titulo"
        :disabled="aba.desabilitado()"
        :id="aba.xml"
        :title="aba.titulo"
        sub
        accordion="sub_aneel"
      >
        <template #append-title>
          <div v-if="aba.preenchido">
            <b-badge variant="success" class="ml-2">Preenchido</b-badge>
          </div>
        </template>
        <aneel-comprovante
          :projeto-editavel="projetoEditavel"
          :id-upload="`up${i}`"
          v-if="aba.componente == 'ComprovanteXML'"
          @salvar="
            salvarXML(
              $event,
              aba,
              'Salvar comprovante',
              'Comprovante salvo com sucesso'
            )
          "
          @deletar="
            deletarXML($event, aba, false, 'Deseja deletar o comprovante?')
          "
          @download="download($event, aba)"
          :ref="aba.xml"
          :itens="aba.objeto"
        />
        <aneel-11
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel11'"
          @salvar="
            salvarXML(
              $event,
              aba,
              'Salvar comprovante',
              'Comprovante salvo com sucesso'
            )
          "
          @deletar="deletarXML($event, aba)"
          @deletar2="deletarXML($event, aba, true)"
          @download="download($event, aba)"
          @download2="download($event, aba, true)"
          :ref="aba.xml"
          :itens="aba.objeto"
          :itens2="aba.objeto2"
        />
        <aneel-13
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel13'"
          @salvar="
            salvarXML(
              $event,
              aba,
              'Salvar comprovante',
              'Comprovante salvo com sucesso'
            )
          "
          @deletar="deletarXML($event, aba)"
          @deletar2="deletarXML($event, aba, true)"
          @download="download($event, aba)"
          @download2="download($event, aba, true)"
          :ref="aba.xml"
          :itens="aba.objeto"
          :itens2="aba.objeto2"
        />

        <aneel-1
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel1'"
          @salvar="salvarXML($event, aba)"
          @deletar="deletarXML($event, aba)"
          @download="download($event, aba)"
          :ref="aba.xml"
          :itens="aba.objeto"
        />
        <aneel-3
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel3'"
          @salvar="
            salvarXML($event, aba, 'Salvar Ofício', 'Ofício salvo com sucesso')
          "
          @deletar="deletarXML($event, aba)"
          @download="download($event, aba)"
          :ref="aba.xml"
          :itens="aba.objeto"
        />
        <aneel-4
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel4'"
          @salvar="salvarXML($event, aba)"
          @deletar="deletarXML($event, aba)"
          @download="download($event, aba)"
          :ref="aba.xml"
          :itens="aba.objeto"
        />
        <aneel-6
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel6'"
          @salvar="salvarXML($event, aba)"
          @deletar="deletarXML($event, aba)"
          @download="download($event, aba)"
          :ref="aba.xml"
          :itens="aba.objeto"
        />
        <aneel-8
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel8'"
          @salvar="salvarXML($event, aba)"
          @deletar="deletarXML($event, aba)"
          @download="download($event, aba)"
          :ref="aba.xml"
          :itens="aba.objeto"
        />
        <aneel-10
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel10'"
          @salvar="salvarXML($event, aba)"
          @deletar="deletarXML($event, aba)"
          @deletar2="deletarXML($event, aba, true)"
          @download="download($event, aba)"
          @download2="download($event, aba, true)"
          :ref="aba.xml"
          :itens="aba.objeto"
          :itens2="aba.objeto2"
        />
        <aneel-12
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel12'"
          @salvar="salvarXML($event, aba)"
          @deletar="deletarXML($event, aba)"
          @deletar2="deletarXML($event, aba, true)"
          @download="download($event, aba)"
          @download2="download($event, aba, true)"
          :ref="aba.xml"
          :itens="aba.objeto"
          :itens2="aba.objeto2"
        />
        <aneel-14
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel14'"
          @salvar="
            salvarXML(
              $event,
              aba,
              'Salvar comprovante',
              'Comprovante salvo com sucesso'
            )
          "
          @deletar="deletarXML($event, aba)"
          @download="download($event, aba)"
          :ref="aba.xml"
          :itens="aba.objeto"
        />
        <aneel-15
          :projeto-editavel="projetoEditavel"
          v-if="aba.componente == 'Aneel15'"
          @salvar="
            salvarXML(
              $event,
              aba,
              'Salvar comprovante',
              'Comprovante salvo com sucesso'
            )
          "
          @deletar="deletarXML($event, aba)"
          @download="download($event, aba)"
          :ref="aba.xml"
          :itens="aba.objeto"
        />
      </accordion>
    </b-card>
  </div>
</template>
<script>
import ProjetoService from "@/common/services/projeto/projeto.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "@/common/utils/helpers";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

import Aneel1 from "./componentes/Aneel1";
import AneelComprovante from "./componentes/AneelComprovante";
import Aneel3 from "./componentes/Aneel3";
import Aneel4 from "./componentes/Aneel4";
import Aneel6 from "./componentes/Aneel6";
import Aneel8 from "./componentes/Aneel8";
import Aneel10 from "./componentes/Aneel10";
import Aneel12 from "./componentes/Aneel12";
import Aneel14 from "./componentes/Aneel14";
import Aneel15 from "./componentes/Aneel15";

import Aneel11 from "./componentes/Aneel11";
import Aneel13 from "./componentes/Aneel13";

import Accordion from "@/components/card/Accordion";

export default {
  mixins: [AlertasMixin],
  props: {
    projetoId: {
      required: true,
    },
    projetoIdBase: {
      required: true,
    },
    projetoEditavel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AneelComprovante,

    Aneel1,
    Aneel3,
    Aneel4,
    Aneel6,
    Aneel8,
    Aneel10,
    Aneel12,
    Aneel14,
    Aneel15,
    Aneel11,
    Aneel13,

    Accordion,
  },
  data: () => ({
    abas: [],
  }),

  methods: {

    podeDeletar(index) {
      return index <= 5 && this.abas[6].preenchido;
    },

    criarAbas: function () {
      this.abas = [
        {
          titulo: "1 - XML da proposta",
          componente: "Aneel1",
          xml: "xml-projeto",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            return false;
          },
        },
        {
          titulo: "2 - Comprovante XML da proposta",
          componente: "ComprovanteXML",
          xml: "comprovante-xml-projeto",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            return false;
          },
        },
        {
          titulo: "3 - Parecer avaliação inicial ANEEL",
          componente: "Aneel3",
          xml: "avaliacao-inicial-aneel",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[1].objeto;
            let aba0 = this.abas[0].objeto;

            return (
              aba.length == 0 || !aba0.find((el) => el.avaliacaoInicial == "S")
            );
          },
        },
        {
          titulo: "4 - XML de interesse",
          componente: "Aneel4",
          xml: "xml-interesse",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[1].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "5 - Comprovante XML de interesse",
          componente: "ComprovanteXML",
          xml: "comprovante-xml-interesse",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[1].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "6 - XML de inicio",
          componente: "Aneel6",
          xml: "xml-inicio",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[4].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "7 - Comprovante XML de inicio",
          componente: "ComprovanteXML",
          xml: "comprovante-xml-inicio",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[4].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "8 - XML de prorrogação",
          componente: "Aneel8",
          xml: "xml-prorrogacao",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[6].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "9 - Comprovante XML de prorrogação",
          componente: "ComprovanteXML",
          xml: "comprovante-xml-prorrogacao",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[6].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "10 - Arquivos do relatório técnico final",
          componente: "Aneel10",
          xml: "xml-final",
          xml2: "relatorio-final-pdf",
          objeto: [],
          objeto2: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[6].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "11 - Comprovantes do relatório técnico final",
          componente: "Aneel11",
          xml: "comprovante-xml-relatorio-final",
          xml2: "comprovante-pdf-relatorio-final",
          objeto: [],
          objeto2: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[6].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo:
            "12 - Arquivos do relatório de auditoria contábil e financeiro",
          componente: "Aneel12",
          xml: "xml-auditoria",
          xml2: "relatorio-auditoria-pdf",
          objeto: [],
          objeto2: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[6].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo:
            "13 - Comprovantes do relatório de auditoria contábil e financeiro",
          componente: "Aneel13",
          xml: "comprovante-xml-relatorio-auditoria",
          xml2: "comprovante-pdf-relatorio-auditoria",
          objeto: [],
          objeto2: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[6].objeto;
            return aba.length == 0;
          },
        },
        {
          titulo: "14 - Parecer de avaliação final ANEEL",
          componente: "Aneel14",
          xml: "avaliacao-final-aneel",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba11 = this.abas[10].objeto;
            let aba13 = this.abas[12].objeto;
            return aba11.length == 0 || aba13.length == 0;
          },
        },
        {
          titulo: "15 - Defesa sobre parecer final",
          componente: "Aneel15",
          xml: "comprovante-defesa-final",
          objeto: [],
          preenchido: false,
          desabilitado: () => {
            let aba = this.abas[6].objeto;
            return aba.length == 0;
          },
        },
      ];

      this.buscarAbas(null);
    },

    buscarAbas: function (aba) {
      this.abas
        .filter((el) => {
          return el.xml && (aba ? el.componente == aba : true);
        })
        .forEach((element) => {
          ProjetoService.listarXML(element.xml, this.projetoIdBase).then(
            (response) => {
              element.objeto = response.data.data.itens;
              element.preenchido = element.objeto.length > 0;
            }
          );
        });

      this.abas
        .filter((el) => {
          return el.xml2 && (aba ? el.componente == aba : true);
        })
        .forEach((element) => {
          ProjetoService.listarXML(element.xml2, this.projetoIdBase).then(
            (response) => {
              element.objeto2 = response.data.data.itens;
            }
          );
        });
    },

    salvarXML: function (
      form,
      aba,
      mensagemConfirmacao = "Deseja gerar o XML?",
      mensagemSucesso = "XML gerado com sucesso!"
    ) {
      if (aba.xml2) {
        if (form.form2) {
          if (!this.$refs[aba.xml][0].validateState("form2-")) return;
        } else {
          if (!this.$refs[aba.xml][0].validateState("form1-")) return;
        }
      } else {
        if (!this.$refs[aba.xml][0].validateState()) return;
      }

      if (form.arquivoObrigatorio) {
        for (let index = 0; index < form.arquivoObrigatorio.length; index++) {
          if (!form[form.arquivoObrigatorio[index].campo]) {
            this.alertaErro(
              `Campo ${form.arquivoObrigatorio[index].nomeCampo} é obrigatório!`
            );
            return;
          }
        }
      }

      this.confirmar(
        !form.form2 ? mensagemConfirmacao : "Deseja salvar?",
        ""
      ).then((confirmado) => {
        if (confirmado) {
          form.ProjetoId = this.projetoId;
          ProjetoService.salvarXML(form.form2 ? aba.xml2 : aba.xml, form)
            .then(() => {
              this.alertaSucesso(
                !form.form2 ? mensagemSucesso : "Salvo com sucesso"
              );
              this.buscarAbas(aba.componente);
              this.$emit("update");
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.alertaErro(err.response.data.errors);
              } else this.alertaErro("Erro ao salvar");
            });
        }
      });
    },

    deletarXML: function (id, aba, xml2 = false) {
      this.confirmar("Deseja deletar?", "").then((confirmado) => {
      if (confirmado) {        
        if (this.podeDeletar(this.abas.indexOf(aba))) {
        return this.alertaErro("Não foi possível deletar. É preciso deletar o comprovante do XML de início primeiro.");
      }
          ProjetoService.deletarXML(xml2 ? aba.xml2 : aba.xml, id)
            .then(() => {
              this.alertaSucesso("Deletado com sucesso");
              this.buscarAbas(aba.componente);
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.alertaErro(err.response.data.errors);
              } else this.alertaErro("Erro ao deletar");
            });
        }
      });
    },

    download: function (itemId, aba, xml2 = false) {
      this.$store.dispatch(START_LOADING);

      ProjetoService.downloadXML(xml2 ? aba.xml2 : aba.xml, itemId)
        .then((response) => {
          helpers.baixarArquivo(response.data, response.headers);
          this.alertaSucesso("Download do Arquivo Concluido!");
        })
        .catch((err) => {
          console.log(err);
          this.alertaErro("Erro ao fazer Download do Arquivo");
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },

  mounted: function () {
    this.criarAbas();
  },

  computed: {
    tela: function () {
      return this.$route.name;
    },
  },
  watch: {
    abas: {
      handler: function () {
        this.$emit("retornarAbas", this.abas);
      },
      deep: true,
    },
  },
};
</script>
<style>
.aneel .nav-item {
  border-bottom: 1px solid #e5e5e5;
}
</style>